const data = {
  id: 1,
  title: 'Look, listen and choose True/False.',
  subTitle: 'Nhìn hình, nghe và chọn True/False',
  audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/a4f2eae8-0d0d-4dd9-b94f-6d321f189c66.mp3',
  imageUrl: 'https://cloud.softech.vn/storage/SachSo/Images/Vocabulary/Starters/girl.png',

  answers: [
    { id: 1, answer: 'False', isCorrect: false },
    { id: 2, answer: 'True', isCorrect: true },
  ],
  settings: {
    answers: {
      direction: 'horizontal',
      bulletType: 'none',
      // bulletType: 'character',
      // bulletType: 'number',
    },
  },
};

export default data;
